module.exports = __webpack_public_path__ + "img/sssj2c.8d5d4ee5.png";